import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { first, takeUntil } from "rxjs/operators";
import { CommandDetails } from "../../models/commandDetails.model";
import { CommandHandelingState } from "../../models/commandHandelingState.enum";
import { CommandLog } from "../../models/commandLog.model";
import { CommandStepState } from "../../models/commandStepState.model";
import { CommandService } from "../../services/Command.service";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";
import { CommandState } from "../../models/commandState.enum";

@Component({
  selector: "app-failed-command-details",
  templateUrl: "./failed-command-details.component.html",
  styleUrls: ["./failed-command-details.component.scss"],
})
export class FailedCommandDetailsComponent implements OnDestroy, AfterViewInit {
  @Input() commandId: string;
  commandLogs: CommandLog[] = [];
  commandDetails: CommandDetails;
  commandHandelingState = CommandHandelingState;
  commandStepState = CommandStepState;
  skipPreValidation = true;
  commandState = CommandState;
  ShowRestartButton = false;
  ValidateSurveyCommand = "ValidateSurveyCommand";
  ValidateInsideSurveyBuildingCommand = "ValidateInsideSurveyBuildingCommand";

  constructor(
    private commandService: CommandService,
    private route: ActivatedRoute,
    private router: Router,
    private permissionService: PermissionsService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  toCommands() {
    this.router.navigate(["/admin/commands"], {
      queryParams: { load: "true" },
    });
  }

  ngAfterViewInit() {
    this.route.paramMap.pipe(first()).subscribe((data) => {
      this.commandId = data.get("id");
    });

    this.loadData();
  }

  refreshData() {
    this.loadData();
  }

  canRestartCommand(): boolean {
    return this.permissionService.allowed(PermissionsEnum.RestartCommand);
  }

  private loadData() {
    this.commandService
      .getLogsForCommand(this.commandId)
      .pipe(first())
      .subscribe((res) => {
        this.commandLogs = this.formatXMLMessages(
          res.sort((a, b) => b.loggedOn.valueOf() - a.loggedOn.valueOf())
        );
        this.commandLogs.forEach((l) => (l.collapsed = true));
      });

    this.commandService
      .getCommandDetails(this.commandId)
      .pipe(first())
      .subscribe((res) => {
        this.commandDetails = res;
        if (
          (this.commandDetails.CommandState == CommandState.Failed ||
            this.commandDetails.CommandState == CommandState.Delayed) &&
          (this.commandDetails.Title == this.ValidateSurveyCommand ||
            this.commandDetails.Title ==
              this.ValidateInsideSurveyBuildingCommand)
        )
          this.ShowRestartButton = true;
      });
  }

  restartCommand(id: string) {
    this.commandService
      .restartCommand(id, this.skipPreValidation)
      .subscribe((res) => {
        this.refreshData();
        this.ShowRestartButton = false;
      });
  }

  private formatXMLMessages(commandLogs): CommandLog[] {
    const returnVlaue = commandLogs.map((log) => {
      if (
        !log.message.startsWith("<s:Envelope") &&
        !log.message.startsWith("<soap:Envelope")
      )
        return log;

      const xmlDoc = new DOMParser().parseFromString(
        log.message,
        "application/xml"
      );

      const xsltDoc = new DOMParser().parseFromString(
        [
          '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
          '  <xsl:strip-space elements="*"/>',
          '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
          '    <xsl:value-of select="normalize-space(.)"/>',
          "  </xsl:template>",
          '  <xsl:template match="node()|@*">',
          '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
          "  </xsl:template>",
          '  <xsl:output indent="yes"/>',
          "</xsl:stylesheet>",
        ].join("\n"),
        "application/xml"
      );

      const xsltProcessor = new XSLTProcessor();
      xsltProcessor.importStylesheet(xsltDoc);
      const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
      log.message = new XMLSerializer().serializeToString(resultDoc);
      return log;
    });
    return returnVlaue;
  }
}
